module.exports = __webpack_public_path__ + "static/media/FoF.f87f8fc0.jpeg";